import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { SystemService } from 'src/app/service/system.service';
import { FileService } from 'src/app/service/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cand-english-test',
  templateUrl: './cand-english-test.component.html',
  styleUrls: ['./cand-english-test.component.scss']
})
export class CandEnglishTestComponent implements OnInit {
  appStatusEnglishTest: any = 30;
  showLoader: boolean = false;
  creating: boolean = false;
  // candidateData: any;
  // isExcelFile: any;
  keys: any;
  dataSheet = new Subject();
  // @ViewChild('inputFile') inputFile: any;

  url: string = "";
  imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  uploadImage: any;
  countries: any;
  regions: any;
  provinces: any;
  city: any;
  maritalStatus: any;
  milStatus: any;
  candId: any;
  candNameEn: any;
  candNameAr: any;
  candNatId: any;
  candCode: any;
  photoPath: any = "assets/images/stud-image.png";
  candMoodleData: any;
  // moodleHyperLink: any;
  englishReportFile: any;
  englishReportFileName: any;
  ieltsFilename = "";
  itemFileNameWithoutPath="";
  candStatus:any;

  canEnglishTestForm = new FormGroup({
    candCode: new FormControl('', [
      // Validators.required,
    ]),
    // part2ReadingA: new FormControl('', [
    //   Validators.required,
    // ]),
    // part2ReadingB: new FormControl('', [
    //   Validators.required,
    // ]),
    // part3WritingA: new FormControl('', [
    //   Validators.required,
    // ]),
    // part3WritingB: new FormControl('', [
    //   Validators.required,
    // ]),
    // total: new FormControl('', [
    //   Validators.required,
    // ]),
    // studentLeveEPWriting: new FormControl('', [
    //   Validators.required,
    // ]),
    // studentLeveEPSpeaking: new FormControl('', [
    //   Validators.required,
    // ]),
    thanaweyaAma: new FormControl('', [
   //   Validators.required,
    ]),
    // moodleLink: new FormControl('', [
    //   Validators.required,
    // ]),
    englishReport: new FormControl('', [
     // Validators.required,
    ]),
    cefr: new FormControl('', [
     // Validators.required,
    ]),
    rn: new FormControl('', [
    //  Validators.required,
    ]),
  });


  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    private systemService: SystemService,
    public translate: TranslateService,
    private fileService: FileService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.candId = params['candId'] || "";

        if (this.candId != "") {
          this.getCandById(this.candId);
        } else {

          this.toastr.warning(this.translate.instant('NOT_FOUND'));
          this.router.navigate(['/admission/candidate-inquiry']);
        }
      });
  }
  getCandById(candId: number) {
    this.showLoader = true;
    this.admService.getCandidateById(candId).subscribe(
      data => {
        this.canEnglishTestForm.controls.candCode.setValue(data.candCode);
        this.candNameEn = data.fullNameEn;
        this.candNameAr = data.fullNameAr;
        this.candNatId = data.nidNo;
        this.candCode = data.candCode;
        this.photoPath = `${environment.API_URL_UTIL}/api/downloadFile/${data.photoFilename}`;
        // console.log(this.photoPath);
        this.candStatus=data.appstatusid;
        this.getCandMoodleTest();
      },
      error => {
        this.showLoader = false;
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  updateStatusEnglishTest() {
    if(this.candStatus>=55){
      this.router.navigate(['/admission/candidate-inquiry']);
      this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
      this.creating = false
    }else{
    this.admService.updateStatusEnglishTest(this.candId, this.appStatusEnglishTest)
      .subscribe(
        data => {
          this.router.navigate(['/admission/candidate-inquiry']);
          this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          this.creating = false
        },
        error => {
          this.creating = false
          this.toastr.warning(this.translate.instant('CAN_NOT_UPDATE'));
        },
      );
    }
  }
  canEnglishTestFormSubmit() {
    if (this.canEnglishTestForm.valid) {
      this.creating = true;
      if(this.englishReportFile !=null && this.englishReportFile!="" ){
      this.handleUploadFiles();
      }else{
        this.saveEnglishTest()
      }
    }
    else {
      console.log("non valid");
      this.canEnglishTestForm.markAllAsTouched();
      this.canEnglishTestForm.markAsDirty();
      this.creating = false;
    }
  }

  canEnglishTestFormChange() {

  }

  // readExcelFile(evt: any) {
  //   let data: any, header;
  //   const target: DataTransfer = <DataTransfer>(evt.target);
  //   this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
  //   if (target.files.length > 1) {
  //     this.inputFile.nativeElement.value = '';
  //   }
  //   if (this.isExcelFile) {
  //     this.showLoader = true;
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (e: any) => {
  //       /* read workbook */
  //       const bstr: string = e.target.result;
  //       const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

  //       /* grab first sheet */
  //       const wsname: string = wb.SheetNames[0];
  //       const ws: XLSX.WorkSheet = wb.Sheets[wsname];

  //       /* save data */
  //       data = XLSX.utils.sheet_to_json(ws, { defval: "" });
  //     };

  //     reader.readAsBinaryString(target.files[0]);
  //     reader.onloadend = (e) => {
  //       this.showLoader = false;
  //       this.keys = Object.keys(data[0]);
  //       if (data.length > 0) {

  //         data.forEach((element: any, index: number) => {
  //           if (index == 2) {
  //             let keys = Object.keys(element);
  //             this.canEnglishTestForm.controls.part1GrammarVocabulary.setValue(element[keys[0]]);
  //             this.canEnglishTestForm.controls.part2ReadingA.setValue(element[keys[1]]);
  //             this.canEnglishTestForm.controls.part2ReadingB.setValue(element[keys[2]]);
  //             this.canEnglishTestForm.controls.part3WritingA.setValue(element[keys[3]]);
  //             this.canEnglishTestForm.controls.part3WritingB.setValue(element[keys[4]]);
  //             this.canEnglishTestForm.controls.total.setValue(element[keys[5]]);
  //             this.canEnglishTestForm.controls.studentLeveEPWriting.setValue(element[keys[6]]);
  //             this.canEnglishTestForm.controls.studentLeveEPSpeaking.setValue(element[keys[7]]);
  //             this.canEnglishTestForm.controls.thanaweyaAma.setValue(element[keys[8]]);
  //             this.canEnglishTestForm.controls.moodleLink.setValue(element[keys[9]]);
  //           }
  //         });
  //         this.dataSheet.next(data);
  //       } else {
  //         this.removeDataForUploadedFile();
  //         this.toastr.warning(this.translate.instant("PLEASE_ENTER_EXCEL_FILE"));
  //       }
  //     }
  //   } else {
  //     this.inputFile.nativeElement.value = '';
  //   }
  // }

  removeDataForUploadedFile() {
    // this.inputFile.nativeElement.value = '';
    this.dataSheet.next(null);
    this.keys = null;
  }

  getCandMoodleTest() {
    this.admService.getCandEnglishTest(this.candId).subscribe(
      data => {
        this.candMoodleData = data;
        // this.canEnglishTestForm.controls.part1GrammarVocabulary.setValue(data.p1Gv);
        // this.canEnglishTestForm.controls.part2ReadingA.setValue(data.p2Ra);
        // this.canEnglishTestForm.controls.part2ReadingB.setValue(data.p2Rb);
        // this.canEnglishTestForm.controls.part3WritingA.setValue(data.p3Wa);
        // this.canEnglishTestForm.controls.part3WritingB.setValue(data.p3Wb);
        // this.canEnglishTestForm.controls.total.setValue(data.moodleTotal);
        // this.canEnglishTestForm.controls.studentLeveEPWriting.setValue(data.slWr);
        // this.canEnglishTestForm.controls.studentLeveEPSpeaking.setValue(data.slSp);
        this.canEnglishTestForm.controls.thanaweyaAma.setValue(data.thanaweya);
        // this.canEnglishTestForm.controls.moodleLink.setValue(data.moodleLink);

        this.canEnglishTestForm.controls.cefr.setValue(data.cefr);
        this.canEnglishTestForm.controls.rn.setValue(data.rn);

        if (data.ieltsFilename != null && data.ieltsFilename.length > 0) {
          this.ieltsFilename = `${environment.API_URL_UTIL}/api/downloadFile/${data.ieltsFilename}`;
          this.itemFileNameWithoutPath=data.ieltsFilename;
        }

        // this.moodleHyperLink = data.moodleLink;
        // candMoodleData
        this.showLoader = false;
      },
      error => {
        this.showLoader = false
      }
    );
  }

  changeFile(event: any) {
    let typesAccept = ['application/pdf'];
    // Max size 200 MEGA
    let maxSize = 209715200;
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.englishReportFile = event.target.files[0];
        return true;
      } else {
        this.canEnglishTestForm.controls.englishReport.reset();
        this.canEnglishTestForm.controls.englishReport.markAsDirty();
        this.canEnglishTestForm.controls.englishReport.markAsTouched();

        if (currentFile.size > maxSize) {
          this.toastr.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
        }
        return false;
      }
    } else {
      return false;
    }
  }

  handleUploadFiles() {
    let formData = new FormData();

    let fname = this.englishReportFile.name.split('.').slice(0, -1).join('.')
    let fext = this.englishReportFile.name.split('.').pop()
    this.englishReportFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.englishReportFile, this.englishReportFileName);

    console.log("file name : " + this.englishReportFileName);


    this.fileService.uploadFile(formData).subscribe(
      data => {
        this.saveEnglishTest()
      },
      error => {
        this.creating = false
        this.toastr.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
      }
    );
  }

  saveEnglishTest() {
    let fileName="";
    if(this.englishReportFileName==null){
      fileName=this.itemFileNameWithoutPath;
    }else{
      fileName=this.englishReportFileName;
    }
    this.admService.addcanEnglishTest(
      this.candId,
      // this.canEnglishTestForm.controls.part2ReadingA.value,
      // this.canEnglishTestForm.controls.part2ReadingB.value,
      // this.canEnglishTestForm.controls.part3WritingA.value,
      // this.canEnglishTestForm.controls.part3WritingB.value,
      // this.canEnglishTestForm.controls.total.value,
      // this.canEnglishTestForm.controls.studentLeveEPWriting.value,
      // this.canEnglishTestForm.controls.studentLeveEPSpeaking.value,
      this.canEnglishTestForm.controls.thanaweyaAma.value,
      // this.canEnglishTestForm.controls.moodleLink.value,
      this.canEnglishTestForm.controls.cefr.value,
      this.canEnglishTestForm.controls.rn.value,
      fileName
    )
      .subscribe(
        data => {
          this.updateStatusEnglishTest();
        },
        error => {
          this.creating = false
          this.toastr.warning(this.translate.instant('CAN_NOT_UPDATE'));
        }
      );
  }
}

